import Vue from 'vue'
import axios from 'axios'
import { Notification } from 'element-ui'
import router from '@/router'

// 导入 NProgress 包对应的JS和CSS
import NProgress from 'nprogress'

let baseURL = 'https://robottest.yingerfashion.com'
if (location.host === 'robot.yingerfashion.com') {
  baseURL = 'https://robot.yingerfashion.com'
}
window.baseURL = baseURL

axios.defaults.baseURL = baseURL
axios.defaults.timeout = 60000

// 在 request 拦截器中，展示进度条 NProgress.start()
axios.interceptors.request.use(config => {
  NProgress.start()
  config.headers.Authorization = localStorage.getItem('token')
  // 在最后必须 return config
  return config
})

// 在 response 拦截器中，隐藏进度条 NProgress.done()
axios.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  if (error.message.indexOf('Network Error') > -1) {
    Notification.error({
      message: '网络错误'
    });
  } else if (error.message.indexOf('timeout') > -1) {
    Notification.error({
      message: '网络连接超时'
    });
  } else {
    let err = error.response && error.response.data || {}
    let message = err.message || err.msg || (err.error && err.error.message) || err.MessageContent || error.message
    if (message.indexOf('token is expired') >= 0 || message.indexOf('过期') >= 0) {
      setTimeout(() => {
        localStorage.clear()
        router.push('/login')
      }, 2000);
    }
    Notification.error({
      message
    });
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axios